import Service from "./Service";

class BusBasePriceApiService extends Service {
  constructor() {
    super("api/BusBasePrices");
  }

  async getAll() {
    let result = await this.get(``, (status, data) => {
      return data;
    });
    return result;
  }

  async update(year, payload) {
    let result = await this.post(`/${year}`, payload, (status, data) => {
      return data;
    });
    return result;
  }

  async deleteByYear(year) {
    let result = await this.delete(`/${year}`, (status, data) => {
      return data;
    });
    return result;
  }

  async add(payload) {
    let result = await this.post(``, payload, (status, data) => {
      return data;
    });
    return result;
  }
}

export default new BusBasePriceApiService();
